export default __webpack_public_path__ + "static/media/uqbar-logo-symbol.adf1b4fd.svg";